import { Loading } from '@/components/loading/Loading';
import { PurchaseOrderProvider } from '@/services/purchaseOrders/PurchaseOrderService';
import { PurchaseOrderNavigationProvider } from '@/services/purchaseOrders/validation/PurchaseOrderNavigationService';
import { FC, Suspense } from 'react';
import { Outlet, useParams } from 'react-router';

export const PurchaseOrderContainer: FC = () => {
  const { companyId, partnerId, orderId } = useParams<{ companyId: string; partnerId: string; orderId: string }>();

  if (!companyId || !partnerId || !orderId) {
    throw Error('Missing page parameter');
  }

  return (
    <PurchaseOrderProvider
      customerId={companyId}
      partnerId={partnerId}
      orderId={orderId === 'create' ? undefined : orderId}
    >
      <PurchaseOrderNavigationProvider>
        <PurchaseOrderInnerContainer />
      </PurchaseOrderNavigationProvider>
    </PurchaseOrderProvider>
  );
};

const PurchaseOrderInnerContainer: FC = () => {
  return (
    <div className="flex h-full flex-1 overflow-hidden">
      <div className="flex w-full">
        <Suspense fallback={<Loading className="h-screen" />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
};
